import { ISendEmailUseCase } from "../../../presentation/useCases/create/send_email_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * SendEmailUseCase
 */

export class SendEmailUseCase implements ISendEmailUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async sendEmail(
    idObra: number,
    sendTo: string,
    subject: string,
    body: string,
    attachment: string,
  ): Promise<void> {
    const emails = sendTo.split(';');

    emails.forEach(e => e.trim());

    await this.repository.sendEmail(
      idObra,
      emails,
      subject,
      body,
      attachment,
    );
  }
}
